export class Ventas {
  constructor(data = {}) {
    // Normalizar las claves de entrada (mayúsculas y minúsculas)
    const normalizedData = this.normalizeKeys(data);
    
    // IDs
    this.id_ventas = normalizedData.id_ventas || normalizedData.Id_ventas || 0;
    this.id_cliente = normalizedData.id_cliente || normalizedData.Id_cliente || 0;
    this.id_driver = normalizedData.id_driver || normalizedData.Id_driver || 0;
    this.id_sucursal = normalizedData.id_sucursal || normalizedData.Id_sucursal || 0;
    
    // Estados y estatus
    this.estado = normalizedData.estado || normalizedData.Estado || 'ACTIVO';
    this.estatus = normalizedData.estatus || normalizedData.Estatus || 'CREADO';
    
    // Fechas y tiempo
    this.fecha = normalizedData.fecha || normalizedData.Fecha || new Date().toISOString().split('T')[0];
    this.hora = normalizedData.hora || normalizedData.Hora || new Date().toTimeString().split(' ')[0];
    this.total_venta = normalizedData.total_venta || normalizedData.Total_venta || 0;
    
    // Nombres (agregados por el API cuando hace JOIN)
    this.nombre_cliente = normalizedData.nombre_cliente || normalizedData.Nombre_cliente || '';
    this.nombre_driver = normalizedData.nombre_driver || normalizedData.Nombre_driver || 'POR ASIGNAR';
    this.tlf_cliente = normalizedData.tlf_cliente || normalizedData.Tlf_cliente || '';
    this.tlf_driver = normalizedData.tlf_driver || normalizedData.Tlf_driver || null; // ✅ NUEVO
    
    // Tiempo de preparación
    this.tiempo = normalizedData.tiempo || normalizedData.Tiempo || 0;
    
    // Fechas y hora de modificación (para el contador)
    this.fecha_modi = normalizedData.fecha_modi || normalizedData.Fecha_modi || null;
    this.hora_modi = normalizedData.hora_modi || normalizedData.Hora_modi || null;
    
    // ⭐ IMAGEN del driver - MAYÚSCULA igual que Logo en Sucursal
    this.Imagen = normalizedData.imagen || normalizedData.Imagen || '';
    
    console.log('🔍 Venta creada - Imagen:', this.Imagen ? `${this.Imagen.length} caracteres` : 'vacío');
    console.log('🔍 nombre_driver:', this.nombre_driver);
    console.log('🔍 tlf_driver:', this.tlf_driver); // ✅ NUEVO
  }

  // Normalizar claves (igual que en Sucursal)
  normalizeKeys(data) {
    if (!data) return {};
    
    const normalized = {};
    for (const [key, value] of Object.entries(data)) {
      normalized[key.toLowerCase()] = value;
      normalized[key] = value; // Mantener original también
    }
    return normalized;
  }

  // Validación
  isValid() {
    return (
      this.id_cliente > 0 &&
      this.id_sucursal > 0 &&
      this.total_venta >= 0 &&
      this.fecha &&
      this.hora
    );
  }

  getValidationErrors() {
    const errors = [];
    if (this.id_cliente <= 0) errors.push('ID de cliente inválido');
    if (this.id_sucursal <= 0) errors.push('ID de sucursal inválido');
    if (this.total_venta < 0) errors.push('Total de venta inválido');
    if (!this.fecha) errors.push('Fecha requerida');
    if (!this.hora) errors.push('Hora requerida');
    return errors;
  }

  // Formato para enviar al API (con nombres en mayúsculas iniciales)
  toApiFormat() {
    return {
      Id_ventas: this.id_ventas,
      Id_cliente: this.id_cliente,
      Id_driver: this.id_driver,
      Id_sucursal: this.id_sucursal,
      Estado: this.estado,
      Estatus: this.estatus,
      Fecha: this.fecha,
      Hora: this.hora,
      Total_venta: this.total_venta,
      Tiempo: this.tiempo,
      Fecha_modi: this.fecha_modi,
      Hora_modi: this.hora_modi,
      Imagen: this.Imagen
    };
  }

  // Para debugging
  toDebug() {
    return {
      id_ventas: this.id_ventas,
      id_cliente: this.id_cliente,
      id_driver: this.id_driver,
      id_sucursal: this.id_sucursal,
      estado: this.estado,
      estatus: this.estatus,
      fecha: this.fecha,
      hora: this.hora,
      total_venta: this.total_venta,
      nombre_cliente: this.nombre_cliente,
      nombre_driver: this.nombre_driver,
      tlf_cliente: this.tlf_cliente,
      tlf_driver: this.tlf_driver, // ✅ NUEVO
      tiempo: this.tiempo,
      fecha_modi: this.fecha_modi,
      hora_modi: this.hora_modi,
      Imagen: this.Imagen ? `[${this.Imagen.length} caracteres]` : 'Sin imagen'
    };
  }

  // ✅ MÉTODO PARA OBTENER URL DE IMAGEN
  getImageUrl(imageField = 'imagen') {
    const image = this.Imagen;
    if (!image) return null;
    if (image.startsWith('data:') || image.startsWith('http')) return image;
    return `data:image/jpeg;base64,${image}`;
  }

  hasImage(imageType = 'imagen') {
    return !!(this.Imagen && this.Imagen.length > 0);
  }

  getImageSizeInMB() {
    if (!this.Imagen) return 0;
    try {
      const base64Data = this.Imagen.replace(/^data:image\/[^;]+;base64,/, '');
      const decoded = atob(base64Data);
      return (decoded.length / (1024 * 1024)).toFixed(2);
    } catch (error) {
      console.error('Error calculando tamaño de imagen:', error);
      return 0;
    }
  }
}